import React from 'react';

const Translations = () => {
  return (
    <div className="translations-page">
      <h2>Traduções</h2>
      <p>Gerencie as traduções do sistema.</p>
    </div>
  );
};

export default Translations;
